import { render, staticRenderFns } from "./BindGuests.vue?vue&type=template&id=68ef973c"
import script from "./BindGuests.vue?vue&type=script&lang=js"
export * from "./BindGuests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports